import { uploadVimeoMiddleware } from './middlewares/uploadVimeo'
const bulletinMiddlewares = [uploadVimeoMiddleware]
export default bulletinMiddlewares
